<template>
  <div id="smartSearch">
    <div class="box">
      <div>智能搜索</div>
      <div class="search-box">
        <el-input class="search" v-model="input" placeholder="请输入搜索内容"></el-input>
        <el-button type="primary" @click="addSearchTile">添加</el-button>
      </div>
      <div class="search-title">
        如果需要搜索多个关键字，请使用
        <span style="color:red">"空格"</span>把关键字隔开。把填写完的条件添加到以下列表，最多添加十个条件
      </div>
      <div v-show="searchList.length > 0" v-loading="loading" class="search-list">
        <el-tag
          v-for="(item,index) in searchList"
          :key="index"
          closable
          type="success"
          @close="itemClose(index)"
        >{{item.title}}</el-tag>
        <el-button style="margin-left:10px;margin-top:10px;" type="primary" @click="search">立即搜索</el-button>
      </div>
      <div class="table-box" v-show="tableData.length > 0">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="title" label="名称"></el-table-column>
          <el-table-column prop="brand" label="品牌"></el-table-column>
          <el-table-column prop="specification" label="规格"></el-table-column>
          <el-table-column prop="selling_price" label="价格"></el-table-column>
          <el-table-column prop="keyword" label="关键字"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="addCar(scope.row.id)">加入购物车</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      input: '',
      searchList: [],
      tableData: [],
      searchKeys: [],
      loading:true
    }
  },
  created(){

  },
  activated(){
    this.tableData = [];
    this.searchList = [];
  },
  methods: {
    alert_success(message) {
      this.$message({
        message: message,
        type: 'success',
        offset: 200
      })
    },
    alert_error(message) {
      this.$message({
        message: message,
        type: 'error',
        offset: 200
      })
    },
    addSearchTile() {
      if (this.input == '') {
        this.alert_error('条件不能为空')
        return
      }
      if (this.searchList.length >= 10) {
        this.alert_error('条件不能超过十个')
        return
      }
      var item = {}
      item.title = this.input
      this.searchList.push(item)
      this.input = ''
    },
    itemClose(index) {
      this.searchList.splice(index, 1)
    },
    search() {
      var qs = require('qs')
      let config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
      var formData = this.searchList
      this.axios
        .post(this.serve + '/smartSearch', qs.stringify(formData), config)
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.tableData = data.data.results
          } else {
            this.tableData = []
          }
        })
    },
    addCar(id) {
      if (this.$store.state.isLogin) {
        this.loading = false
        var formData = {
          mobile: this.$cookies.get('user'),
          token: this.$cookies.get('token'),
          id: id,
          number: 1
        }
        this.axios
          .get(this.serve + '/member/add_car', {
            params: formData
          })
          .then(res => {
            if (res.data.status == 'success') {
                this.alert_success('加入购物车成功')
            } else {
              this.alert_error('加入购物车失败')
            }
            this.loading = true
          })
      } else {
        this.$router.push('/login')
      }
    }
  }
}
</script>
<style lang='scss'>
#smartSearch {
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .el-tag {
    margin-top: 10px;
  }
  width: 100%;
  min-height: 650px;
  border-top: 2px solid #e2211c;
  .box {
    width: 1200px;
    min-height: 600px;
    margin: 20px auto 0 auto;
    padding-bottom: 20px;
    .search-box {
      margin-top: 20px;
      .search {
        width: 800px;
        margin-right: 30px;
      }
    }
    .search-title {
      margin-top: 10px;
    }
    .search-list {
      border: 1px solid #ccc;
      margin-top: 10px;
      padding-bottom: 10px;
      padding-left: 10px;
      padding-right: 10px;
    }
    .table-box {
      margin-top: 10px;
    }
  }
}
</style>